import { render, staticRenderFns } from "./menuGroupCatalogList.vue?vue&type=template&id=3d5ecba5&scoped=true"
import script from "./menuGroupCatalogList.vue?vue&type=script&lang=js"
export * from "./menuGroupCatalogList.vue?vue&type=script&lang=js"
import style0 from "./menuGroupCatalogList.vue?vue&type=style&index=0&id=3d5ecba5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ecba5",
  null
  
)

export default component.exports